/**
 * Reparo dos telefones de Negócios locais já gravados no navegador (25/10/2026). Até então o
 * painel não lia o país do endereço do Maps e gravava o telefone sem +55 e sem a marca de
 * celular quando o lote vinha sem país. Roda uma vez por pessoa e navegador; as listas
 * corrigidas voltam à fila de backup para o servidor receber a versão certa.
 */
import { useEffect } from 'react';
import { repairLocalPlaces } from '../data/localDb';
import { requestListBackup } from '../lib/listBackupQueue';
import { repairPlacePhones } from '../lib/normalizePlace';

const REPAIRED_PREFIX = 'place_phones_repaired_v1_';
const running = new Set<string>();

function wasRepaired(userId: string): boolean {
  try {
    return localStorage.getItem(REPAIRED_PREFIX + userId) === '1';
  } catch {
    return true;
  }
}

function markRepaired(userId: string): void {
  try {
    localStorage.setItem(REPAIRED_PREFIX + userId, '1');
  } catch {
    /* storage indisponível: o reparo roda de novo e não muda o que já está certo */
  }
}

export async function runPlacePhoneRepair(userId: string): Promise<number> {
  if (!userId || wasRepaired(userId) || running.has(userId)) return 0;
  running.add(userId);
  try {
    const result = await repairLocalPlaces(userId, repairPlacePhones);
    markRepaired(userId);
    for (const listId of result.listIds) void requestListBackup(listId);
    return result.repaired;
  } finally {
    running.delete(userId);
  }
}

export function usePlacePhoneRepair(userId: string | undefined): void {
  useEffect(() => {
    if (!userId) return;
    // Falhou (IndexedDB indisponível, outra aba no meio): tenta na próxima carga.
    runPlacePhoneRepair(userId).catch(() => undefined);
  }, [userId]);
}
